import accessibleAutocomplete from 'accessible-autocomplete'

// import { Loader } from '@googlemaps/js-api-loader'
// import {
//   MarkerClusterer,
//   SuperClusterAlgorithm,
// } from '@googlemaps/markerclusterer'
import {
  apiKey,
  pinSvg,
  options,
  center,
  defaultZoom,
  regionStyles,
  noStyle,
} from './map-options'
import {
  // adherentSvg,
  regionIds,
  departementsIds,
  habitantSvg,
  // regions,
  // departements,
} from './map-data'

export default class BlockMap {
  constructor(element) {
    this.element = element
    this.categoriesEl = element.querySelectorAll('.js-map-category')
    this.filtersEl = element.querySelector('.js-map-filters')
    this.categories = []
    this.categoriesEl.forEach((el) => {
      const { index, title, typology } = el.dataset
      this.categories[typology] = {
        index,
        title: decodeURI(title),
        typology: decodeURI(typology),
        active: true,
        button: el,
      }
    })

    this.data = window.shareholderDatas

    window.callback_map_function = () => {
      this.start()
    }

    // const loader = new Loader({ apiKey, version: 'beta' })
    // loader.load().then((google) => {
    //   this.google = google
    //   this.start()
    // })
  }

  start() {
    this.initMap()
    this.addMarkers()
    // this.addCluster()
    this.initFilters()
    this.infowindow = new google.maps.InfoWindow({ disableAutoPan: true })
    this.bindEvents()
    this.initSliderCategories();
  }

  initFilters() {
    this.filtersOpened = false

    // array search
    this.arraySearch = [...shareholderDatas]
    this.arraySearch = this.arraySearch.sort((a, b) =>
      a.title.localeCompare(b.title),
    )
    this.arraySearchKeys = this.arraySearch.map((item, index) => {
      return item.title
      // return { id: index, text: item.title }
    })

    this.searchForm = this.element.querySelector('.js-map-search-form')
    this.searchForm.addEventListener('submit', (e) => {
      e.preventDefault()
      e.stopPropagation()
    })

    this.autocompleteContainer = this.searchForm.querySelector(
      '.js-autocomplete-container',
    )
    accessibleAutocomplete({
      element: this.autocompleteContainer,
      id: 'search', // To match it to the existing <label>.
      source: this.arraySearchKeys,
      displayMenu: 'overlay',
      confirmOnBlur: false,
      placeholder: this.searchForm.dataset.placeholder,
      onConfirm: (label) => {
        const item = this.getItemFromLabel(label)
        this.currentSearchResultItem = item
        this.setSearchActive()
        this.zoomToLabel(label)
        this.openInfowindow(item)
      },
    })
    this.inputSearch = this.autocompleteContainer.querySelector('input')
    const btResetSearch = this.searchForm.querySelector('.js-search-reset')
    if (btResetSearch) {
      btResetSearch.addEventListener('click', () => {
        this.unsetSearchActive()
        this.zoomToDefault()
      })
    }

    // region
    this.selectRegion = this.element.querySelector('.js-regions')


    // departement
    this.selectDepartement = this.element.querySelector('.js-departements')
    this.selectDepartementHTML = this.selectDepartement.innerHTML

  }

  bindEvents() {
    // open / close filters
    const btFilter = this.element.querySelector('.js-bt-filter')
    btFilter.addEventListener('click', (e) => {
      e.stopPropagation()
      e.preventDefault()
      
      if (this.filtersOpened) {
        this.closeFilters()
      } else {
        this.openFilters()
      }
    })

    const btReset = this.element.querySelector('.js-bt-filter-reset')
    btReset.addEventListener('click', () => {
      this.resetFilters()
    })

    // categories
    this.categoriesEl.forEach((el) => {
      const { typology } = el.dataset
      const category = this.categories[decodeURI(typology)]
      category.button.addEventListener('click', () => {
        // if(!this.firsClickDone){ // au premier click, on décoche tout les autres
        if(this.element.querySelectorAll('.js-map-category.js-active').length == this.element.querySelectorAll('.js-map-category').length){ // si toutes catégorie sélectionnée, on decelectionne toutes sauf celle clickée
          this.categoriesEl.forEach((el) => {
            const { typology } = el.dataset
            this.categories[decodeURI(typology)].active = false;
            el.classList.remove('js-active')
          })
          category.button.classList.add('js-active')
          category.active = true
          // this.firsClickDone = true;
        }else{
          category.active = !category.active
          if (category.active) {
            category.button.classList.add('js-active')
          } else {
            category.button.classList.remove('js-active')
          }
          if(this.element.querySelectorAll('.js-map-category.js-active').length == 0){
            this.categoriesEl.forEach((el) => {
              const { typology } = el.dataset
              this.categories[decodeURI(typology)].active = true;
              el.classList.add('js-active')
            })
          }
        }

        this.updateMarkers()
      })
    })

    // dropdown regions
    this.selectRegion.addEventListener('change', (e) => {
      let select = e.currentTarget
      if (select.selectedIndex !== 0) {
        let option = select.options[select.selectedIndex]
        this.zoomToOption(option)
        this.updateDepartementsList(option.dataset.departements.split(','))
      } else {
        this.updateDepartementsList()
        this.zoomToDefault()
      }
    })
    // dropdown departements
    this.selectDepartement.addEventListener('change', (e) => {
      let select = e.currentTarget
      if (select.selectedIndex !== 0) {
        let option = select.options[select.selectedIndex]
        this.zoomToOption(option)
      } else {
        this.zoomToDefault()
      }
    })

    // shortcuts
    this.currentShortcut = this.element.querySelector('.current')

    const shortcuts = this.element.querySelectorAll('.js-map-shortcut')
    shortcuts.forEach((shortcut) => {
      shortcut.addEventListener('click', () => {
        const { lat, lng, zoom } = shortcut.dataset
        this.zoomTo(parseFloat(lat), parseFloat(lng), parseInt(zoom))

        this.currentShortcut.classList.remove('current')
        this.currentShortcut = shortcut
        this.currentShortcut.classList.add('current')
      })
    })
  }

  openFilters() {
    if (!this.filtersOpened) {
      this.filtersOpened = true
      this.filtersEl.classList.add('js-filters--opened')

      setTimeout(() => {
        hideOnClickOutside('.js-map-filterWrapper', () => this.closeFilters())
      })
    }
  }
  closeFilters() {
    if (this.filtersOpened) {
      this.filtersOpened = false
      this.filtersEl.classList.remove('js-filters--opened')
    }
  }

  updateDepartementsList(departements = []) {
    // sur iphone, display none permet pas de cacher les options d'un select, on les supprime du coup, et on les remet quand on filtre a nouveau
    this.selectDepartement.innerHTML = this.selectDepartementHTML
    if(departements.length > 0){
      for (let i = 0, lg = this.selectDepartement.options.length; i < lg; i++) {
        const opt = this.selectDepartement.options[i]
        if (
          // departements.length > 0 &&
          opt.dataset.numero &&
          opt.dataset.numero !== '' &&
          departements.indexOf(opt.dataset.numero) === -1
        ) {
          // opt.style.display = 'none'
          // opt.style.visibility = 'hidden'
          // opt.disabled = 'true'
          opt.classList.add('js-departementToRemove')
        } // else {
          // opt.style.display = ''
          // opt.style.visibility = ''
          // opt.disabled = ''
        //}
      }
    }
    $('.js-departementToRemove').remove()
    this.selectDepartement.selectedIndex = 0
  }

  initMap() {
    const mapEl = this.element.querySelector('.js-map-container')
    this.map = new google.maps.Map(mapEl, options)

    let layers = [
      'ADMINISTRATIVE_AREA_LEVEL_1',
      'ADMINISTRATIVE_AREA_LEVEL_2',
      'COUNTRY',
    ];
    // layersRegions.forEach((layer) => {
    //   let featureLayer = this.map.getFeatureLayer(layer)
    //   featureLayer.style = (options) => {
    //     if (regionIds.indexOf(options.feature.placeId) != -1) {
    //       return regionStyles
    //     }
    //   }
    // })


    this.map.addListener("bounds_changed", () => {
      layers.forEach((layer) => {
        let featureLayer = this.map.getFeatureLayer(layer);
        featureLayer.style = (options) => {
          if (regionIds.indexOf(options.feature.placeId) != -1) {
            return regionStyles;
          }
        }
      })
      if(this.map.getZoom() > 8 ){
        layers.forEach((layer) => {
          let featureLayer = this.map.getFeatureLayer(layer);
          featureLayer.style = (options) => {
            if (departementsIds.indexOf(options.feature.placeId) != -1) {
              return regionStyles;
            }
          }
        })
      }
    });

    // use once to generate placeID to restrict style to french departments, then save it in map-datas.js departementsIds array
    // this.getPlaceIdDepartements();
  }

  getPlaceIdDepartements(){
    var PlacesService = new google.maps.places.PlacesService(this.map);

    // use once to generate placeID to restrict style to french departments
    function findPlaceId(request) {
      placesService.findPlaceFromQuery(request, function (results, status) {
        if (status === this.google.maps.places.PlacesServiceStatus.OK) {
          console.log(request);
          console.log(results[0]);
        }
      });
    }
    let depToPlaceIdArray = [];
    for (let i = 0, depLen = departements.length; i < depLen; i++) {
      let request = {
        query: departements[i],
        fields: ['place_id'],
      };
      PlacesService.findPlaceFromQuery(request, function(results, status) {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
          for (var j = 0; j < results.length; j++) {
            console.log(departements[i] +' : '+ results[j]['place_id']);
            depToPlaceIdArray[departements[i]] = results[j]['place_id'];
          }
        }
      });
    }
    // console.log(depToPlaceIdArray);
  }

  resetFilters() {
    this.selectDepartement.value = 'empty'
    this.selectRegion.value = 'empty'
    this.inputSearch.value = ''
    this.unsetSearchActive()
    this.closeInfowindow()
    this.zoomToDefault()
    this.updateDepartementsList()
  }

  zoomTo(lat, lng, zoom = 10) {
    this.map.panTo(new google.maps.LatLng(lat, lng))

    if (zoom) {
      this.map.setZoom(zoom)
    }
  }
  zoomToOption(option) {
    var zoom = (option.dataset.zoom) ? parseInt(option.dataset.zoom) : 9;
    if($(window).width() < 768){
      var zoom = (option.dataset.zoommobile) ? parseInt(option.dataset.zoommobile) : zoom;
    }
    this.zoomTo(option.dataset.lat, option.dataset.lng, zoom)
  }
  zoomToLabel(label) {
    const item = this.getItemFromLabel(label)
    if (item) {
      const { lat, lng, zoom } = item
      this.zoomTo(lat, lng, zoom)
    }
  }
  zoomToDefault() {
    this.zoomTo(center.lat, center.lng, defaultZoom)
  }
  getItemFromLabel(label) {
    const filtered = this.arraySearch.filter(function (el) {
      return el.title === label
    })
    if (filtered.length > 0) {
      return filtered[0]
    } else {
      false
    }
  }

  setSearchActive() {
    this.searchForm.classList.add('js-search-active')
  }
  unsetSearchActive() {
    this.currentSearchResultItem = null
    this.searchForm.classList.remove('js-search-active')
  }

  updateMarkers() {
    const availableMarkers = []
    this.data.forEach((item) => {
      const visible = item.typology ? this.categories[item.typology].active : false;
      item.marker.setVisible(visible)
    })
  }

  addMarkers() {
    this.markers = []

    this.data.forEach((item) => {
      const color = decodeURI(item.typology_color)
      const svg = getColoredPin(color)

      let m = new google.maps.Marker({
        position: { lat: item.lat, lng: item.lng },
        map: this.map,
        icon: {
          url: 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(svg),
          scaledSize: new google.maps.Size(29, 41),
        },
      })
      m.addListener('click', () => {
        this.zoomTo(item.lat, item.lng)
        this.openInfowindow(item)
      })
      m.addListener('mouseover', () => {
        this.openInfowindow(item)
      })
      m.addListener('mouseout', () => {
        if (item !== this.currentSearchResultItem) {
          this.closeInfowindow(item)
        }
      })

      this.markers.push(m)
      item.marker = m
    })
  }

  // addCluster() {
  //   const algorithm = new SuperClusterAlgorithm({
  //     radius: 180,
  //   })

  //   this.markerCluster = new MarkerClusterer({
  //     map: this.map,
  //     markers: this.markers,
  //     algorithm,
  //     // gridSize: 6000,
  //     renderer: {
  //       // palette: interpolateRgb('#c30d25', '#39a9e5'),
  //       render: function ({ count, position }, stats) {
  //         // const color = this.palette(
  //         //   (count - 2) / (stats.clusters.markers.max - 2),
  //         // )
  //         const color = '#303a7d'
  //         const svg = window.btoa(
  //           `<svg fill="${color}" width="240" height="240" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240"><circle cx="120" cy="120" opacity=".8" r="70" /></svg>`,
  //         )

  //         return new google.maps.Marker({
  //           position,
  //           icon: {
  //             url: `data:image/svg+xml;base64,${svg}`,
  //             scaledSize: new google.maps.Size(60, 60),
  //           },
  //           label: {
  //             text: String(count),
  //             color: 'rgba(255,255,255,1)',
  //             fontSize: '14px',
  //             fontWeight: 'bold',
  //           },
  //           // adjust zIndex to be above other markers
  //           zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
  //         })
  //       },
  //     },
  //   })
  // }

  openInfowindow(item) {
    let populationLine = ''
    if (item.population_count) {
      populationLine = `<div class="map__info-line">
        ${habitantSvg} <span>${item.population_count} habitants</span>
      </div>`
    }
    let dateLine = ''
    if (item.date) {
      dateLine = `<div class="map__info-line">
        ${adherentSvg} <span>${item.date}</span>
      </div>`
    }

    const contentString = `<div id="content" class="map__info map__info--${item.typology_color}">
        <div id="siteNotice"></div>
        <h1 id="firstHeading" class="map__info-heading">${item.title}</h1>
        ${populationLine}
        ${dateLine}
        </div>`

    this.infowindow.setContent(contentString)

    this.infowindow.open({
      anchor: item.marker,
      map: this.map,
      shouldFocus: false,
    })
  }
  closeInfowindow() {
    this.infowindow.setContent('')
    this.infowindow.close()
  }

  initSliderCategories() {
    var $slider = $(".js-map__categories-slider");
    $slider.slick({
      variableWidth: true,
      centerMode: false,
      infinite: false,
      // responsive: [
      //   {
      //     breakpoint : 500,
      //     settings : {
      //       dots: true,
      //       prevArrow: false,
      //       nextArrow: false
      //     }
      //   },
      //   // {
      //   //  breakpoint : 820,
      //   //  settings : {
      //   //    dots: true,
      //   //    prevArrow: false,
      //   //    nextArrow: false
      //   //  }
      //   // }
      // ],
      // centerMode: false,
      //       dots: false,
      //       slidesToShow: 1,
      //       slideToScroll: 1,
      // adaptiveHeight: true,
      prevArrow: '<button type="button" class="slick-prev"><svg class="icon icon-caret" aria-hidden="true"><use xlink:href="#icon-caret" /></svg>   </button>',
      nextArrow: '<button type="button" class="slick-next"><svg class="icon icon-caret" aria-hidden="true"><use xlink:href="#icon-caret" /></svg>   </button>'
    });    

    $slider.on('afterChange', function (e, slick) {
      var lElRect = slick.$slides[slick.slideCount - 1].getBoundingClientRect();
      var rOffset = lElRect.x + lElRect.width;
      var wraRect = $('.slick-list', $slider).get(0).getBoundingClientRect();
      if (rOffset < (wraRect.x + wraRect.width)) {
      $('.slick-next', $slider).addClass('slick-disabled');
      }
    });
  }
}

const colors = {
  red: '#c30d25',
  'blue-light': '#39a9e5',
  'light-blue': '#39a9e5',
  blue: '#303a7d',
  'dark-blue': '#303a7d',
  pink: '#ff93a1',
  black: '#000000',
  grey: '#707070',
}
function mapColor(color) {
  return colors[color]
}
function getColoredPin(color) {
  return pinSvg.replace('currentColor', colors[color])
}
// function ParseDMS(input) {
//   var parts = input.split(/[^\d\w]+/)
//   console.log('DMS parts', parts)
//   var lat = ConvertDMSToDD(parts[0], parts[1], parts[2], 'N')
//   var lng = ConvertDMSToDD(parts[3], parts[4], parts[5], 'W')
//   console.log(lat, lng)
//   return {
//     lat,
//     lng,
//   }
// }
// function ConvertDMSToDD(degrees, minutes, seconds, direction) {
//   var dd =
//     parseInt(degrees) + parseInt(minutes) / 60 + parseInt(seconds) / (60 * 60)
//   // if (direction == 'S' || direction == 'W') {
//   //   dd = dd * -1
//   // } // Don't do anything for N or E
//   return dd
// }

export function hideOnClickOutside(selector, callback) {
  const outsideClickListener = (event) => {
    const $target = $(event.target)
    if (!$target.closest(selector).length && $(selector).is(':visible')) {
      callback()
      removeClickListener()
    }
  }

  const removeClickListener = () => {
    document.removeEventListener('click', outsideClickListener)
  }

  document.addEventListener('click', outsideClickListener)
}
